module.exports = __webpack_public_path__ + "static/media/add award category.5ee42a87.svg";